/* eslint-disable import/no-extraneous-dependencies */
import React, { useEffect } from "react";
import { useQuery } from "@redux-requests/react";
import { Button, Grid, Typography, makeStyles, CssBaseline, Container } from "@material-ui/core";
import { ChevronLeft as ChevronLeftIcon } from "@material-ui/icons";
import { QrReader } from "fork-react-qr-reader";
import { useIntl } from "react-intl";
import { Link as RouterLink, useHistory, useParams } from "react-router-dom";
import { capitalize, get } from "lodash";
import { useDispatch } from "react-redux";
import { Loader } from "../components";
import useNotifications from "../hooks/useNotifications";
import { useQueryParams } from "../hooks";
import { createQrScanLog, getPhysicalRoom } from "../ducks/actions";
import * as types from "../ducks/types";

const useStyles = makeStyles(theme => ({
  title: {
    marginTop: theme.spacing(4)
  }
}));

const QrScanPage = () => {
  const history = useHistory();
  const { ok, ko } = useNotifications();
  const { roomId } = useParams();
  let [{ action }] = useQueryParams();
  const intl = useIntl();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getPhysicalRoom({ id: roomId }));
  }, [dispatch, roomId]);

  const {
    data: { physical_room: physicalRoom },
    loading: physicalRoomLoading
  } = useQuery({
    type: types.GET_PHYSICAL_ROOM,
    defaultData: { physical_room: {} }
  });

  const classes = useStyles();

  action = action === "exit" ? "exit" : "enter";

  const createQrScanLogRequest = async params => {
    const response = await dispatch(createQrScanLog(params));

    if (response.error) {
      let errorMessage = "";
      if (response.error.response.status === 404) {
        errorMessage = get(
          response.error,
          "response.data.errors[0].detail",
          intl.formatMessage({
            defaultMessage: "Operation failed",
            id: "Hooks.ActionRequest.OperationFailed"
          })
        );
      } else if (response.error.response.status === 422) {
        errorMessage = get(
          response.error,
          "response.data.qr_scan_log.additional_data.error_message",
          intl.formatMessage({
            defaultMessage: "Operation failed",
            id: "Hooks.ActionRequest.OperationFailed"
          })
        );
      }
      ko(errorMessage);
    } else {
      ok(
        intl.formatMessage({
          defaultMessage: "Operation succedeed",
          id: "Hooks.ActionRequest.OperationSuccedeed"
        })
      );
    }

    history.push(`/physical_rooms/${roomId}`);

    return response;
  };

  const onScanSuccess = result => {
    if (result) {
      createQrScanLogRequest({ userId: result, roomId, action });
    }
  };

  const onError = error => {
    if (error) {
      history.push(`/physical_rooms/${roomId}`);
      ko(error);
    }
  };

  return (
    <>
      <CssBaseline />
      <Container maxWidth="xl" component="main">
        <Loader loading={physicalRoomLoading}>
          <Grid container spacing={2}>
            <Grid xs={2}>
              <Button component={RouterLink} to={`/physical_rooms/${roomId}`} fullWidth>
                <ChevronLeftIcon fontSize="large" /> &nbsp;
                <Typography variant="h5">
                  {intl.formatMessage({
                    id: "Pages.QrScanPage.Back",
                    defaultMessage: "Back"
                  })}
                </Typography>
              </Button>
            </Grid>
            <Grid xs={10} />
          </Grid>
          <Typography variant="h2" align="center" className={classes.title}>
            {intl.formatMessage(
              {
                id: "Pages.QrScanPage.Scan",
                defaultMessage: "{action} {roomName}"
              },
              { action: capitalize(action), roomName: physicalRoom.name }
            )}
          </Typography>
          <QrReader
            onResult={(result, error) => {
              if (result) {
                onScanSuccess(result.text);
              }

              if (error && error.name === "TypeError") {
                onError(
                  intl.formatMessage({
                    defaultMessage: "Cannot open camera",
                    id: "Pages.QrScanPage.Error"
                  })
                );
              }
            }}
            constraints={{ facingMode: "environment" }}
          />
        </Loader>
      </Container>
    </>
  );
};

export default QrScanPage;
